var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.13992 20.96C3.98992 19.9 2.23992 18.14 1.16992 15.99C1.16992 15.96 1.18992 15.91 1.18992 15.88C2.53992 16.28 3.93992 16.58 5.31992 16.81C5.55992 18.21 5.84992 19.59 6.24992 20.94C6.21992 20.94 6.16992 20.96 6.13992 20.96Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8198 21.06C16.2398 19.65 16.5998 18.24 16.8298 16.81C18.2298 16.58 19.5998 16.28 20.9498 15.88C20.9398 15.92 20.9698 15.97 20.9698 16C19.8698 18.2 18.0498 19.99 15.8198 21.06Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.8298 5.30996C16.5998 3.87996 16.2498 2.45996 15.8198 1.07996C18.1098 2.17996 19.9598 4.02996 21.0598 6.31996C19.6598 5.89996 18.2598 5.55996 16.8298 5.30996Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.33984 5.32004C3.90984 5.54004 2.48984 5.90004 1.08984 6.32004C2.15984 4.09004 3.94984 2.27004 6.14984 1.17004C6.17984 1.17004 6.22984 1.20004 6.25984 1.20004C5.85984 2.55004 5.56984 3.92004 5.33984 5.32004Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.19994 5.08C7.47994 3.56 7.82994 2.04 8.32994 0.58C8.34994 0.49 8.33994 0.42 8.34994 0.34C9.22994 0.13 10.1199 0 11.0599 0C11.9999 0 12.8999 0.13 13.7599 0.34C13.7699 0.43 13.7699 0.5 13.7899 0.58C14.2899 2.05 14.6399 3.56 14.9199 5.08C12.3499 4.79 9.75994 4.79 7.18994 5.08H7.19994Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0.58 13.81C0.49 13.79 0.42 13.8 0.34 13.79C0.13 12.91 0 12.02 0 11.08C0 10.14 0.13 9.23997 0.34 8.37997C0.43 8.36997 0.5 8.36997 0.58 8.34997C2.05 7.85997 3.55 7.49997 5.08 7.21997C4.8 9.78997 4.8 12.38 5.08 14.95C3.55 14.67 2.04 14.32 0.58 13.82V13.81Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.8001 13.79C21.7101 13.8 21.6401 13.79 21.5601 13.81C20.0901 14.3 18.5801 14.66 17.0601 14.94C17.3501 12.37 17.3501 9.77996 17.0601 7.20996C18.5801 7.48996 20.1001 7.83996 21.5601 8.33996C21.6501 8.35996 21.7201 8.36996 21.8001 8.36996C22.0101 9.24996 22.1401 10.14 22.1401 11.07C22.1401 12 22.0101 12.91 21.8001 13.78V13.79Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.8102 21.5601C13.7902 21.6501 13.7902 21.7201 13.7802 21.8001C12.9202 22.0101 12.0102 22.1401 11.0802 22.1401C10.1502 22.1401 9.24022 22.0101 8.37022 21.8001C8.36022 21.7101 8.37021 21.6401 8.35021 21.5601C7.86021 20.0901 7.50021 18.5901 7.22021 17.0601C8.50021 17.2001 9.79022 17.3001 11.0902 17.3001C12.3902 17.3001 13.6802 17.2001 14.9602 17.0601C14.6802 18.5901 14.3302 20.0901 13.8302 21.5601H13.8102Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.9002 15.24C6.5502 12.47 6.5502 9.66995 6.9002 6.89995C9.6702 6.54995 12.4702 6.54995 15.2402 6.89995C15.5902 9.66995 15.5902 12.47 15.2402 15.24C12.4702 15.59 9.6702 15.59 6.9002 15.24Z",
    fill: "#ACACAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/social_icon.12b9b37dea242041aef0e518c8f832ae.svg";
export { ForwardRef as ReactComponent };